import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { SchemeData } from '../../utils/dashboardData';
interface SchemeDistributionProps {
  data: SchemeData[];
}
const SchemeDistribution: React.FC<SchemeDistributionProps> = ({
  data
}) => {
  const totalValue = data.reduce((sum, item) => sum + item.value, 0);
  const getSchemeLogoUrl = (name: string) => {
    switch (name) {
      case 'Visa':
        return 'https://cdn.magicpatterns.com/uploads/4AYK289tAoefs5UKMeCGRu/Visa_Logo.png';
      case 'MasterCard':
        return 'https://cdn.magicpatterns.com/uploads/1vYo3uhYQcpE27Haf8Bixu/MasterCard_Logo.png';
      case 'UnionPay':
        return 'https://cdn.magicpatterns.com/uploads/mkpVZ2yX93dtJTCkJzVjji/UnionPay_Logo.png';
      case 'PayPak':
        return 'https://cdn.magicpatterns.com/uploads/fztxH1Zm6zdRKvuAw79Xb6/PayPak_Logo.png';
      case 'RAAST':
        return 'https://cdn.magicpatterns.com/uploads/nYL4tGVTuPASUdRtomRefU/RAAST_Logo.png';
      default:
        return '';
    }
  };
  const CustomTooltip = ({
    active,
    payload
  }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return <div className="bg-white/90 backdrop-blur-md p-4 border border-slate-200 shadow-xl rounded-xl" data-id="element-266">
          <div className="flex items-center space-x-2 mb-3 pb-2 border-b border-slate-100" data-id="element-267">
            <div className="w-3 h-3 rounded-full" style={{
            backgroundColor: data.color
          }} data-id="element-268"></div>
            <span className="font-bold text-slate-900" data-id="element-269">{data.name}</span>
          </div>
          <div className="space-y-2 text-sm" data-id="element-270">
            <div className="flex justify-between gap-6" data-id="element-271">
              <span className="font-medium text-slate-500" data-id="element-272">Value:</span>
              <span className="font-bold text-slate-900" data-id="element-273">
                ₨{data.value.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between gap-6" data-id="element-274">
              <span className="font-medium text-slate-500" data-id="element-275">Count:</span>
              <span className="font-bold text-slate-900" data-id="element-276">
                {data.count.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between gap-6" data-id="element-277">
              <span className="font-medium text-slate-500" data-id="element-278">Share:</span>
              <span className="font-bold text-indigo-600" data-id="element-279">
                {data.percentage}%
              </span>
            </div>
          </div>
        </div>;
    }
    return null;
  };
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 h-full flex flex-col" data-id="element-280">
      <div className="mb-6" data-id="element-281">
        <h2 className="text-lg font-bold text-slate-900" data-id="element-282">Payment Scheme</h2>
        <p className="text-sm text-slate-500 font-medium mt-1" data-id="element-283">
          Distribution by card network
        </p>
      </div>

      <div className="flex-1 flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-284">
        <div className="w-full lg:w-1/2 h-[200px] relative" data-id="element-285">
          <ResponsiveContainer width="100%" height="100%" data-id="element-286">
            <PieChart data-id="element-287">
              <Pie data={data} cx="50%" cy="50%" innerRadius={60} outerRadius={85} paddingAngle={3} dataKey="value" stroke="none" cornerRadius={4} data-id="element-288">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-289" />)}
              </Pie>
              <Tooltip content={<CustomTooltip data-id="element-291" />} data-id="element-290" />
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-292">
            <span className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-293">
              Total Value
            </span>
            <span className="text-xl font-bold text-slate-900 mt-1" data-id="element-294">
              ₨{(totalValue / 1000000).toFixed(1)}M
            </span>
          </div>
        </div>

        <div className="w-full lg:w-1/2" data-id="element-295">
          <div className="overflow-x-auto" data-id="element-296">
            <table className="w-full text-sm" data-id="element-297">
              <thead data-id="element-298">
                <tr className="border-b border-slate-100" data-id="element-299">
                  <th className="text-left font-semibold text-slate-400 pb-3 uppercase tracking-wider text-xs" data-id="element-300">
                    Scheme
                  </th>
                  <th className="text-right font-semibold text-slate-400 pb-3 uppercase tracking-wider text-xs" data-id="element-301">
                    Value
                  </th>
                  <th className="text-right font-semibold text-slate-400 pb-3 uppercase tracking-wider text-xs" data-id="element-302">
                    Share
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-303">
                {data.map((item, index) => <tr key={index} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/50 transition-colors" data-id="element-304">
                    <td className="py-3" data-id="element-305">
                      <div className="flex items-center space-x-3" data-id="element-306">
                        <img src={getSchemeLogoUrl(item.name)} alt={item.name} className="h-5 w-auto object-contain" data-id="element-307" />
                        <span className="font-semibold text-slate-700" data-id="element-308">
                          {item.name}
                        </span>
                      </div>
                    </td>
                    <td className="text-right py-3 font-bold text-slate-900" data-id="element-309">
                      ₨{(item.value / 1000).toFixed(0)}k
                    </td>
                    <td className="text-right py-3" data-id="element-310">
                      <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-lg bg-slate-100 text-xs font-bold text-slate-700" data-id="element-311">
                        {item.percentage}%
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};
export default SchemeDistribution;